export default {
  setCreated: 'SetCreated',
  setCWD: 'SetCWD',
  setManual: 'SetManual',
  boxSet: 'BoxSet',
  complete: 'Complete',
  pullCreated: 'PullCreated',
  cancelled: 'Cancelled',
  pullManual: 'PullManual',
  pullCWD: 'PullCWD',
  poHold: 'POHold',
  poReleased: 'POReleased',
  redMobileNew: 'REDMobileNew',
};
